import { ModalBundle } from '@shiftbase-com/ts-shared/models';

export enum AbsenceManagementDialogStep {
  TEASER,
  BASIC_SETUP,
  SUMMARY,
}

export interface AbsenceManagementDialogData {
  eventData: ModalBundle;
  step?: AbsenceManagementDialogStep;
}

export enum DefaultScheduledShiftAction {
  LEAVE_IN_SCHEDULE = 'leaveInSchedule',
  REMOVE_FROM_SCHEDULE = 'removeFromSchedule',
  MOVE_TO_OPEN_SHIFT = 'moveToOpenShift',
}
export interface OnboardingAbsenceManagementRequest {
  defaultScheduledShiftAction: DefaultScheduledShiftAction;
}
